module.exports = __webpack_public_path__ + "img/conny-f-stage7.f709e9c5.png";